import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ContentProvider } from "./context/ContentContext";
import { SiteStatusProvider } from "./context/SiteStatusContext";
import { Layout } from "./components/Layout";

import Home from "./pages/Home";
import Menu from "./pages/Menu";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import OrderConfirmation from "./pages/OrderConfirmation";
import OrderView from "./pages/OrderView";
import TrackOrder from "./pages/TrackOrder";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import Catering from "./pages/Catering";
import Party from "./pages/Party";
import Offers from "./pages/Offers";
import About from "./pages/About";
import Contact from "./pages/Contact";

import AdminLayout from "./components/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminCoupons from "./pages/admin/AdminCoupons";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminAbandoned from "./pages/admin/AdminAbandoned";
import AdminActivity from "./pages/admin/AdminActivity";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminContent from "./pages/admin/AdminContent";
import AdminDeliveryAreas from "./pages/admin/AdminDeliveryAreas";
import AdminKitchens from "./pages/admin/AdminKitchens";
import AdminNotifications from "./pages/admin/AdminNotifications";
import AdminChefs from "./pages/admin/AdminChefs";
import AdminSecurity from "./pages/admin/AdminSecurity";
import KitchenLogin from "./pages/KitchenLogin";
import KitchenDashboard from "./pages/KitchenDashboard";

const Store = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <ContentProvider>
          <SiteStatusProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Store><Home /></Store>} />
              <Route path="/menu" element={<Store><Menu /></Store>} />
              <Route path="/product/:slug" element={<Store><ProductDetail /></Store>} />
              <Route path="/cart" element={<Store><Cart /></Store>} />
              <Route path="/checkout" element={<Store><Checkout /></Store>} />
              <Route path="/payment/success" element={<Store><PaymentSuccess /></Store>} />
              <Route path="/payment/cancel" element={<Store><PaymentCancel /></Store>} />
              <Route path="/order-confirmation/:orderNumber" element={<Store><OrderConfirmation /></Store>} />
              <Route path="/order/:orderId" element={<Store><OrderView /></Store>} />
              <Route path="/track/:orderNumber" element={<Store><TrackOrder /></Store>} />
              <Route path="/track" element={<Store><TrackOrder /></Store>} />
              <Route path="/login" element={<Store><Login /></Store>} />
              <Route path="/register" element={<Store><Register /></Store>} />
              <Route path="/account" element={<Store><Account /></Store>} />
              <Route path="/catering" element={<Store><Catering /></Store>} />
              <Route path="/party" element={<Store><Party /></Store>} />
              <Route path="/offers" element={<Store><Offers /></Store>} />
              <Route path="/about" element={<Store><About /></Store>} />
              <Route path="/contact" element={<Store><Contact /></Store>} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/kitchen/login" element={<KitchenLogin />} />
              <Route path="/kitchen" element={<KitchenDashboard />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="coupons" element={<AdminCoupons />} />
                <Route path="abandoned" element={<AdminAbandoned />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="activity" element={<AdminActivity />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="delivery-areas" element={<AdminDeliveryAreas />} />
                <Route path="kitchens" element={<AdminKitchens />} />
                <Route path="chefs" element={<AdminChefs />} />
                <Route path="security" element={<AdminSecurity />} />
                <Route path="notifications" element={<AdminNotifications />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
          </SiteStatusProvider>
          </ContentProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
